<template>
    <div class="com-partm4">
        <MyTitle title="能耗监测" />
        <div class="pue-list flex align-center mt-50">
            <div
                v-for="(item, i) in pueList" :key="'pueList' + i"
                class="flex1 pue-item flex flex-direction align-center">
                <p class="label">{{ item.label }}</p>
                <p class="value mt-10">{{ item.value }}</p>
                <p class="unit">{{ item.unit }}</p>
            </div>
        </div>
        <MyTitle class="mt-20" type="2" title="实时总能耗" />
        <div class="p-content flex align-center">
            <myEchart
                v-if="showAllnenghao"
                :id="'showAllnenghao'"
                :options="showAllnenghaoOption" />
        </div>
        <MyTitle class="mt-20" type="2" title="PUE" />
        <div class="p-content flex align-center">
            <myEchart
                v-if="showPUEInfo"
                :id="'showPUEInfo'"
                :options="showPUEInfoOptions" />
        </div>
    </div>
</template>

<script>
import MyTitle from './myTitle1.vue'
import myEchart from "./charts/echarts"
import * as echarts from 'echarts5'
import { dataInterface } from "@/api/dataInterfaceApi"
// import { formatTime } from '@/utils/index'
export default {
    components: {
        MyTitle,
        myEchart
    },
    data() {
        return {
            pueList: [
                {
                    label: '总能耗',
                    value: '',
                    unit: 'kW'
                },
                {
                    label: 'IT能耗',
                    value: '',
                    unit: 'kW'
                },
                {
                    label: 'PUE',
                    value: '',
                    unit: ''
                }
            ],
			// 实施总能耗
			showAllnenghao: false,
			showAllnenghaoOption: {},
            // PUE
            showPUEInfo: false,
            showPUEInfoOptions: {},
			timer: null
        }
    },
	mounted() {
        // 能耗监测
        this.getnenghao()
		// 实时总能耗
		this.getAllnenghao()
		// PUE
		this.getPUEInfo()
		// 定时器
		if(this.timer) {
			clearInterval(this.timer)
		}
        this.timer = setInterval(() =>{
			// 实时总能耗
			this.getAllnenghao()
			// PUE
			this.getPUEInfo()
        }, 60 * 1000 * 15)
    },
	methods: {
        // 能耗监测
        getnenghao() {
			let params = { 
				enCode: 'computingpower-left-nhjc',
			}
			dataInterface.dataFaceApi(params).then(res => {
				let data = res && res[0] || {}
				this.pueList[0].value = data.total_energy
				this.pueList[1].value = data.it_energy
				this.pueList[2].value = data.pue
			})
		},
        // 实时总能耗
        getAllnenghao() {
			let params = { 
				enCode: 'computingpower-left-ssznh',
			}
			this.showAllnenghao = false
			dataInterface.dataFaceApi(params).then(res => {
				console.log(res, '实时总能耗')
				if(!res || !res.length) return
				let xAxisData = []
				let seriesData = []
				res.map(item => {
					xAxisData.push(item.cur_hours)
					seriesData.push(item.total_energy)
				})
				this.showAllnenghaoOption = {
					tooltip: {
						trigger: 'none',
						axisPointer: {
							type: 'cross'
						}
					},
					legend: {},
					xAxis: [
						{
							type: 'category',
							axisTick: {
								alignWithLabel: true
							},
							axisLine: {
								onZero: false,
								lineStyle: {}
							},
							data: xAxisData
						}
					],
					yAxis: [
						{
							name: 'kW',
							type: 'value'
						}
					],
					series: [
						{
							name: '',
							type: 'line',
							smooth: true,
							emphasis: {
								focus: 'series'
							},
							lineStyle: {
								width: 2,
								color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
										offset: 0,
										color: '#F9EBBE'
									},
									{
										offset: 1,
										color: '#F9EBBE'
									}])
							},
							areaStyle: {
								opacity: 0.8,
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: 'rgba(249, 235, 190, 1)'
								},
								{
									offset: 1,
                                    color: 'rgba(249, 235, 190, 0)'
								}])
							},
							data: seriesData,
							tooltip: {
                                valueFormatter: function (value) {
                                    return value + ' kW';
                                }
							}
						},
					]
				}
				this.showAllnenghao = true
			})
        },
        // PUE
        getPUEInfo() {
			let params = { 
				enCode: 'computingpower-left-pue',
			}
			this.showPUEInfo = false
			dataInterface.dataFaceApi(params).then(res => {
				console.log(res, 'PUE')
				if(!res || !res.length) return
				let xAxisData = []
				let seriesData = []
				res.map(item => {
					xAxisData.push(item.cur_hours)
					seriesData.push(item.pue_value)
				})
				this.showPUEInfoOptions = {
					tooltip: {
						trigger: 'none',
						axisPointer: {
							type: 'cross'
						}
					},
					legend: {},
					xAxis: [
						{
							type: 'category',
							axisTick: {
								alignWithLabel: true
							},
							axisLine: {
								onZero: false,
								lineStyle: {}
							},
							data: xAxisData
						}
					],
					yAxis: [
						{
							type: 'value'
						}
					],
					series: [
						{
							name: '',
							type: 'line',
							smooth: true,
							emphasis: {
								focus: 'series'
							},
							lineStyle: {
								width: 2,
								color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
										offset: 0,
										color: '#60B2FF'
									},
									{
										offset: 1,
										color: '#60B2FF'
									}])
							},
							areaStyle: {
								opacity: 0.8,
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: 'rgba(39, 151, 255, 1)'
								},
								{
									offset: 1,
                                    color: 'rgba(181, 217, 250, 0)'
								}])
							},
							data: seriesData,
							tooltip: {
                                valueFormatter: function (value) {
                                    return value;
                                }
							}
						},
					]
				}
				this.showPUEInfo = true
			})
        }
    },
	destroyed() {
		clearInterval(this.timer)
	}
}
</script>

<style lang="scss" scoped>
@import './comm.scss';
.com-partm4 {
    width: 100%;
    // height: 720px;
    .pue-list {
        height: 170px;
        .pue-item {
            height: 100%;
            background: url(~@/assets/images/computility/monitor-icon17.png) center no-repeat;
            background-size: 119px 162px;
            > p {
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: $FontSize24;
            }
            .label {
                height: 38px;
            }
            .value {
                font-family: 'DS-Digital-Bold';
                font-size: $FontSize30;
            }
        }
    }
    .p-content {
        width: 100%;
        height: 290px;
    }
}
</style>